<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 xl9>
        <v-toolbar flat color="transparent">
          <v-toolbar-title>Clients</v-toolbar-title>
          <v-divider class="mx-3" inset vertical />
          <v-btn-toggle v-model="showArchived" mandatory class="hidden-sm-and-down">
            <v-btn flat :value="false">Active</v-btn>
            <v-btn flat :value="true">Archived</v-btn>
          </v-btn-toggle>
          <v-divider class="mx-3 hidden-sm-and-down" inset vertical />
          <v-text-field
            v-model="search"
            append-icon="fas fa-search"
            label="Search"
            single-line
            hide-details
          />
          <v-spacer class="hidden-sm-and-down" />
          <v-btn v-show="!loading" color="primary" dark class="mb-2 hidden-sm-and-down" @click="newItem">New Client</v-btn>
        </v-toolbar>

        <ClientFormDialog
          :client-id="editedItem ? editedItem.id : -1"
          :key="editedItem ? editedItem.id : newItemUniqueId"
          :model-value="showFormDialog"
          @update:modelValue="handleFormSaved"
        />

        <v-data-table
          class="elevation-1 clients-table"
          :headers="tableHeaders"
          :items="tableData"
          :loading="loading"
          :search="search"
          sort-icon="fas fa-sort-alpha-up ml-2"
          must-sort
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate />
          <template slot="items" slot-scope="props">
            <tr @dblclick="editItem(props.item)">
              <td>{{ props.item.name }}</td>
              <td class="text-xs-right" style="white-space: nowrap;">
                <v-btn icon ripple @click="editItem(props.item)">
                  <v-icon small color="blue">fas fa-pencil-alt</v-icon>
                </v-btn>
                <v-btn icon ripple @click="deleteItem(props.item)">
                  <v-icon small color="red">fas fa-trash</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            No clients have been added.
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import api from '../api'
import ClientFormDialog from './ClientFormDialog.vue'
import UserPicker from './UserPicker.vue'

export default {
  components: { ClientFormDialog, UserPicker },
  data: () => ({
    loading: false,
    search: '',

    showArchived: false,
    clients: [],

    showFormDialog: false,
    newItemUniqueId: -1,
    editedIndex: -1,
    editedItem: null,
  }),

  computed: {
    filteredClients() {
      return this.clients.filter((client) => {
        if (this.showArchived && !client.archived || !this.showArchived && client.archived) {
          return false
        }
        return true
      })
    },

    tableHeaders() {
      return [
        { text: 'Name', align: 'left', value: 'name' },
        { text: null, sortable: false, class: 'action-col' },
      ]
    },

    tableData() {
      return this.filteredClients
    },
  },

  methods: {
    close() {
      this.showFormDialog = false
    },

    newItem() {
      this.editedIndex = -1
      this.editedItem = null
      this.showFormDialog = true
    },

    editItem(item) {
      this.editedIndex = this.clients.indexOf(item)
      this.editedItem = { ...item }
      this.showFormDialog = true
    },

    deleteItem(item) {
      if (!confirm('Are you sure you want to delete this client?')) {
        return
      }

      api.endpoints.clients.delete({ id: item.id }).then(() => {
        const index = this.clients.indexOf(item)
        this.clients.splice(index, 1)
      })
    },

    handleFormSaved(value) {
      this.editedItem = null
      this.newItemUniqueId -= 1
      this.showFormDialog = false
      if (value) {
        this.loadClients()
      }
    },

    loadClients() {
      this.loading = true

      api.endpoints.clients
        .getAll()
        .then(({ data }) => {
          this.clients = data['hydra:member']
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
  },

  mounted() {
    if (!this.loading) {
      this.loadClients()
    }
  },
}
</script>

<style lang="scss">
.clients-table .action-col {
  width: 175px;
}
</style>
